_ = require("lodash")
MAX_HOLES = 18

class ScatterDataCtrl
  prepareGoal = (goalSettings) ->
    return unless goalSettings?.avg_total_shot
    return unless goalSettings?.avg_putt
    total_shot_all_holes: goalSettings.avg_total_shot
    total_putt_all_holes: goalSettings.avg_putt * MAX_HOLES

  constructor: (@$scope, @ScatterDataService) ->
    @goal = prepareGoal @$scope.$parent.goalSettings
    @filteredScorecards = []

    if @$scope.$root.paid
      @$scope.$on 'filteredScorecardsUpdated.gnp.analysis', (event, filteredScorecards) =>
        @filteredScorecards = filteredScorecards
    else
      @filteredScorecards = @ScatterDataService.prepareDummyData()

ScatterDataCtrl.$inject = [
  '$scope'
  'ScatterDataService'
]

module.exports = ScatterDataCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/scatter-data/scatter-data-controller.coffee